import { IsOptional, IsString, Matches, MinLength } from 'class-validator';
import { Match } from '../custom-validation/match.decorator';
export class ChangePasswordRequestDto {
  constructor(from?: {
    oldPassword?: string;
    newPassword?: string;
    confirmPassword?: string;
  }) {
    this.oldPassword = from?.oldPassword || '';
    this.newPassword = from?.newPassword || '';
    this.confirmPassword = from?.confirmPassword || '';
  }
  @IsString()
  @IsOptional()
  oldPassword?: string;

  @IsString()
  @Matches(/[0-9]/, { message: 'Must contain number' })
  @Matches(/[A-Z]/, { message: 'Must contain one upper case letter' })
  @Matches(/[a-z]/, { message: 'Must contain one lower case letter' })
  @Matches(/(?=.*[\^@$!%*\.\?&\(\)\-\_])/, {
    message: 'Must contain one special character'
  })
  @MinLength(8)
  newPassword: string;

  @IsString()
  @Matches(/[0-9]/, { message: 'Must contain number' })
  @Matches(/[A-Z]/, { message: 'Must contain one upper case letter' })
  @Matches(/[a-z]/, { message: 'Must contain one lower case letter' })
  @Matches(/(?=.*[\^@$!%*\.\?&\(\)\-\_])/, {
    message: 'Must contain one special character'
  })
  @MinLength(8)
  @Match('newPassword', { message: 'Passwords do not match!' })
  confirmPassword: string;
}
